var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bids-add-bulk-pricing-table-action-column"},[_c('DeleteWithConfirm',{attrs:{"delete-function":_vm.deleteItem}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }